
import React from 'react';
import CloudOffIcon from '@mui/icons-material/CloudOff';
import "./SiteUnavailable.css";

export default function SiteUnavailable() {

    return(
        <React.Fragment>
            <div className={"site-unavailable-root"}>
                <div style={{display: "block", marginTop: "100px"}}>
                    <div style={{marginBottom: "100px", textAlign: "center"}}>
                        <CloudOffIcon style={{transform: "scale(5.0)"}}/>
                    </div>
                    <div style={{fontSize: "32px", fontWeight: 700, marginRight: "30px", marginLeft: "30px", textAlign:"center"}}>
                        The site is currently undergoing maintenance<br/><br/>Try back in a few minutes!
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}